import BaseComponent from '@/components/base';
import { FontStyle } from '@/components/style';
import { goalsMap } from '@/utils/goals-map';

export default class ScoreBanner extends BaseComponent {
  descriptions = {
    recovery:
      'Based off your quiz responses, we recommend our new Biotech Powered Custom Repair products formulated to repair, treat, and strengthen hair.',
    core: 'Based off your quiz responses, we recommend our Custom Core products formulated for your hair type, needs and goals.'
  };

  static get observedAttributes() {
    return ['quiz-data', 'chemical', 'heat', 'mechanical', 'description-type'];
  }

  getLevelLabel(stringValue) {
    const value = parseInt(stringValue);

    if (value < 50) return 'LOW';
    if (value > 50 && value < 80) return 'MEDIUM';
    return 'HIGH';
  }

  render() {
    return `
    ${FontStyle}
    <style>

    :host{
        width: 100%;
    }
    .score-banner-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 16px;
        padding-bottom: 16px;
        padding-top: 24px;
        padding-bottom: 24px;
    }
    .score-legend {
        padding-top: 24px;
        padding-bottom: 24px;
        width: ${this.isSmall ? '100%' : '740px'} ;
    }
    .goals-container {
        display: flex;
        align-items: flex-start;
        gap: 5px;
        justify-content: center;
        max-width: 100%;
        flex-wrap: wrap;
        padding-bottom: 20px;
    }

    .goal-box {
        border-radius: 6px;
        background: #D2EAE5;
        text-transform: capitalize;
        display: flex;
        padding: 4px 12px;
        justify-content: center;
        align-items: center;
        font-size: ${this.isSmall ? `10px` : `14px`};
    }
    </style>
    <div class="score-banner-container">
        <div class="goals-container">
            ${
              this.quizData &&
              this.quizData
                .map(
                  (x) =>
                    `<div
                        class="body-font-2 goal-box"

                        >
                        ${
                          goalsMap.hair.find(
                            (goal) => goal.dataKey.replace('-', ' ') === x
                          )?.name ?? x
                        }
                    </div>`
                )
                .join('')
            }
        </div>
        <progress-bar
                name="chemical"
                leftLabel="YOUR SCORE FOR CHEMICAL DAMAGE:"
                rightLabel="${this.getLevelLabel(this.chemical)}"
                percentage="${this.chemical}"
        ></progress-bar>
        <progress-bar
              name="heat"
              leftLabel="YOUR SCORE FOR HEAT DAMAGE:"
              rightLabel="${this.getLevelLabel(this.heat)}"
              percentage="${this.heat}"
            ></progress-bar>
        <progress-bar
              name="mechanical"
              leftLabel="YOUR SCORE FOR MECHANICAL DAMAGE:"
              rightLabel="${this.getLevelLabel(this.mechanical)}"
              percentage="${this.mechanical}"
            ></progress-bar>
        <div class="score-legend body-font-1">
            ${this.descriptions?.[this.descriptionType] ?? 'Loading'}
        </div>

    </div>
    `;
  }

  get quizData() {
    return (
      this.state['quiz-data']?.answers?.map((answer) => answer.answer) ?? []
    );
  }

  get chemical() {
    return this.state['chemical'];
  }

  get heat() {
    return this.state['heat'];
  }

  get mechanical() {
    return this.state['mechanical'];
  }

  get descriptionType() {
    return this.state['description-type'] ?? 'none';
  }
}
